import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    }
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('session');
    if (token) {
        config.headers.Authorization = `Bearer ${token.replace(/"/g, '')}`;
    }

    return config;
});

/* api.interceptors.response.use(
    (response) => {
        return response;
    }
    , (error) => {
        if (error.response.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }

        return Promise.reject(error);
    }
);*/